import React from 'react';
import { PageContainer } from './DocumentComparison.styles';
import { PageHeader } from '@components/Shared/PageHeader';
import { DocumentComparisonContainer } from '@containers/DocumentComparisonContainer';

export default function DocumentComparison() {
  return (
    <PageContainer>
      <PageHeader
        title="Document Comparison"
        description="Compare two documents to find differences"
      />

      <DocumentComparisonContainer />
    </PageContainer>
  );
}